import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  NgZone,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectorRef,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { IconsComponent } from '../../editor/additional/icons/icons.component';
import { registerErrorSpanBlot } from '../../editor/additional/custom-blots';
import { SkeletonComponent } from '../../editor/additional/placeholders/skeleton.component';
import { ErrorsLoaderComponent } from '../../editor/additional/placeholders/errors-loader.component';
import { icons as i } from './icons';
import { UploadFileComponent } from '../../editor/additional/placeholders/upload-file.component';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';
import { ApidataService } from '../../apidata.service';
import { environment } from '../../../environments/environments';
import { Router } from '@angular/router';
import err from './errors';
import { ModalComponent } from '../../editor/additional/modals/modal.component';
import { PremiumComponent } from '../../premium/premium.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

interface Suggestion {
  id: string;
  type: 'clarity' | 'accuracy' | 'style' | 'syntax';
  wrong?: string;
  correction: string | Array<string>;
  description?: string;
}

// const DEFAULT_TEXT: string = `<p id="0-A">This is example of how people writes when their grammar are not good. Many times, user forgets add article or put comma where not need it. Some person think grammar it's not important but it make reading harder and confusing more. If your write fastly or don't check what you wrote, mistake happens easily. On our website, there is many tools for help, like plagiarism detector, article rewriter, parapharse tool and summarize also. This tool helps you write more better and make your content looks professionaly.We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible.</p>`;
const DEFAULT_TEXT: string = `<p><strong id="0-A">THis is a samplee text.</strong></p><p><br></p><p id=\"1-A\" class=\"\">GrammarIn wills detected you mistakes usng its AI and helps your write better.</p><p id=\"2-A\" class=\"\">he walk to market yesterday and buyed some fruits. the apple was very sweet but she not eat it.</p><p id=\"3-A\" class=\"\">we goes to park every sundays. they is playing with there ball now.</p>`;

@Component({
  selector: 'app-lander',
  standalone: true,
  templateUrl: './lander.component.html',
  styleUrls: ['./lander.component.css'],
  imports: [
    CommonModule,
    IconsComponent,
    ModalComponent,
    TranslateModule,
    PremiumComponent,
    SkeletonComponent,
    UploadFileComponent,
    ErrorsLoaderComponent,
    IconsFreeToolsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LanderComponent implements AfterViewInit {
  @ViewChild('ginEditor', { static: true }) editorElement!: ElementRef;
  @ViewChild('editorToolbar', { static: true }) toolbarElement!: ElementRef;
  @Input() toolName: string = 'Grammar';

  plans = [
    {
      id: 'price_1Q6AFpIcvPV98dDokZi78LKx',
      name: 'Monthly',
      title: 'Monthly',
      price: '$7.50',
      amount: '$7.50',
      originalPrice: '$15.00',
      discount: '50%',
    },
    {
      id: 'price_1Q6AeuIcvPV98dDoc2fUYvhM',
      name: 'Quarterly',
      title: 'Quarterly',
      price: '$15.00',
      amount: '$15',
      originalPrice: '$30.00',
      discount: '50%',
    },
    {
      id: 'price_1Q6Ag7IcvPV98dDoHGszhDz0',
      name: 'Yearly',
      title: 'annual',
      price: '$40.00',
      amount: '$40',
      originalPrice: '$80.00',
      discount: '50%',
    },
  ];

  JSON = JSON;
  Object = Object;
  Array = Array;
  autoInteraction: boolean = false;
  private autoInteractionTimeout: ReturnType<typeof setTimeout> | null = null;
  submitting: boolean = false;
  authState: 'guest' | 'auth' | 'pro' = 'auth';
  authLimits = {
    guest: {
      words: 1000,
    },
    auth: {
      words: 3000,
    },
    pro: {
      words: 10000,
    },
  };

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);
  quillEditor: any;
  editorLoaded: boolean = false;
  editorEnabled: boolean = true;
  profile_id = localStorage.getItem('profile_id') || '1';
  contentLoaded: boolean = false;
  cursor;
  grammarCheckerRoute: boolean = false;

  activeError = null;
  copyText: string = 'editor.Copy';

  showErrorsByType: 'all' | 'accMode' = 'all';
  editorState = {
    words: 0,
    characters: 0,
    batch: null,
    chunks: [],
    results: {},
    errors: {},
    status: { all: 0, accuracy: 0 },
    filteredErrors: {},
  };

  isUploading: boolean = false;
  isPasting: boolean = false;
  loading: boolean = true;

  iconRequireReattachment = false;
  openMenu: HTMLElement | null = null;
  languages: Record<string, { icon: string; name: string }> = {
    'en-us': {
      icon: 'americanFlag',
      name: 'English - US',
    },
    'en-gb': {
      icon: 'britishFlag',
      name: 'English - UK',
    },
    // 'en-za': {
    //   icon: 'southAfricanFlag',
    //   name: 'English - ZA',
    // },
    'en-ca': {
      icon: 'canadianFlag',
      name: 'English - CA',
    },
    'en-au': {
      icon: 'australianFlag',
      name: 'English - AU',
    },
    // 'en-nz': {
    //   icon: 'newZealandFlag',
    //   name: 'English - NZ',
    // },

    _sep1: { icon: '', name: '' },

    es: {
      icon: 'spanishFlag',
      name: 'Spanish',
    },

    pt: {
      icon: 'portugueseFlag',
      name: 'Portuguese',
    },
    // nl: {
    //   icon: 'dutchFlag',
    //   name: 'Dutch',
    // },
    'de-de': {
      icon: 'germanFlag',
      name: 'German',
    },

    // _sep2: { icon: '', name: '' },

    // fr: {
    //   icon: 'frenchFlag',
    //   name: 'French',
    // },
    // el: {
    //   icon: 'greekFlag',
    //   name: 'Greek',
    // },
    // ro: {
    //   icon: 'romanianFlag',
    //   name: 'Romanian',
    // },
    // sv: {
    //   icon: 'swedishFlag',
    //   name: 'Swedish',
    // },

    // ast: {
    //   icon: 'austrianFlag',
    //   name: 'Austrian',
    // },
    // it: {
    //   icon: 'italianFlag',
    //   name: 'Italian',
    // },
  };
  selectedLanguage: keyof typeof this.languages = 'en-us';

  tools = [
    { name: 'editor.grammar-checker', link: '/grammar-checker', active: true },
    { name: 'editor.plagiarism-checker', link: '/plagiarism-checker' },
    { name: 'editor.ai-detector', link: '/ai-content-detector' },
    { name: 'editor.paraphrasing-tool', link: '/paraphrasing-tool' },
    { name: 'editor.text-summarizer', link: '/text-summarizer' },
    { name: 'editor.punctuaiton-checker', link: '/punctuation-checker' },
  ];

  constructor(
    private apiDataService: ApidataService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    //
  }

  private langChangeSub!: Subscription;
  ngAfterViewInit(): void {
    const currentUrl = this.router.url;
    const cleanUrl = currentUrl.split('?')[0];
    this.grammarCheckerRoute = cleanUrl.endsWith('/grammar-checker');

    const l = this.JSON.parse(localStorage.getItem('selectedLanguage')).code;

    this.loadEditor();

    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.updateEditorPlaceholder();
    });

    if (this.profile_id !== '1') {
      this.apiDataService
        .getPreferredLangByProfileID(this.profile_id)
        .subscribe((data) => {
          const language = data.contents.toLowerCase();
          this.selectedLanguage = this.languages.hasOwnProperty(language)
            ? language
            : 'en-us';
          this.iconRequireReattachment = true;
          setTimeout(() => {
            this.iconRequireReattachment = false;
          });
        });
      this.apiDataService
        .getUserProfileContents(this.profile_id)
        .subscribe((data) => {
          if (
            data.contents[0][5] === 'premium_user' ||
            data.contents[0][5] === 'free_trial'
          ) {
            this.authState = 'pro';
          } else {
            this.authState = 'auth';
            // this.showErrorsByType = 'accMode';
          }
        });
    } else {
      this.authState = 'guest';
      // this.showErrorsByType = 'accMode';
    }

    setTimeout(() => {
      this.loading = false;
    }, 1200);

    document.addEventListener('click', this.handleClickOutside);
    localStorage.removeItem('editorValueAI');
    if (l !== 'en') {
      this.selectedLanguage = l;
      this.iconRequireReattachment = true;
      setTimeout(() => {
        this.iconRequireReattachment = false;
      }, 500);
    }
  }

  @ViewChild('uploadHost', { read: ViewContainerRef, static: false })
  uploadHost!: ViewContainerRef;
  loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        Promise.all([import('ngx-quill'), import('quill')]).then(
          ([ngxQuillModule, quillModule]) => {
            this.ngZone.run(() => {
              this.initializeEditor(ngxQuillModule, quillModule);
            });
          }
        );
      });
    }
  }

  initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;
    const icons = Quill.import('ui/icons');
    registerErrorSpanBlot(Quill);
    this.editorLoaded = true;

    icons['bold'] = i.bold;
    icons['italic'] = i.italic;
    icons['underline'] = i.underline;
    icons.align[''] = i.align;
    icons.align['center'] = i.alignCenter;
    icons.align['right'] = i.alignRight;
    icons.list['bullet'] = i.list;
    icons.list['ordered'] = i.orderedList;
    icons['blockquote'] = i.blockquote;

    this.getTranslated('editor.Placeholder', (translated) => {
      const editorConfig = {
        modules: {
          toolbar: {
            container: this.toolbarElement.nativeElement,
          },
        },
        placeholder: translated,
        theme: 'snow',
      };

      this.quillEditor = new Quill(
        this.editorElement.nativeElement,
        editorConfig
      );

      this.quillEditor.root.id = 'mm';

      this.addEventListeners();
      this.loadContent();
    });
  }

  loadContent() {
    this.quillEditor.root.innerHTML = DEFAULT_TEXT;

    if (window.innerWidth < 1203) return;

    setTimeout(() => {
      this.contentLoaded = true;
      this.quillEditor.root.focus();
      this.editorState.chunks = this.Object.keys(err);
      this.editorState.results = err;
      this.formatEditorErrors();
      this.editorState.chunks.forEach((chunk) => {
        this.highlightErrors(chunk);
      });
      setTimeout(() => this.openFirstError(), 950);
    }, 100);
  }

  addEventListeners() {
    if (!this.quillEditor) return;

    const q = this.quillEditor;

    q.on('text-change', (delta, oldDelta, source) => {
      this.computeWordsAndCharactersCount();

      if (!this.contentLoaded) return;

      // this.removeErrorHighlightsFromText();

      setTimeout(() => {
        if (this.isPasting) {
          q.root
            .querySelectorAll('[style]')
            .forEach((el) => el.removeAttribute('style'));
          q.root.querySelectorAll('img').forEach((img) => img.remove());
        }
      }, 0);
    });

    q.root.addEventListener('blur', () => {
      this.editorEnabled =
        !!this.editorState.characters ||
        this.quillEditor.root.innerHTML !== '<p><br></p>';
    });

    q.root.addEventListener('paste', () => {
      this.isPasting = true;
      setTimeout(() => {
        this.isPasting = false;
      }, 100);
    });

    q.root.addEventListener('click', (event: MouseEvent) => {
      this.handleEditorClick(event);
    });

    document
      .querySelector('.scrollable-editor-container')
      .addEventListener('scroll', () => {
        if (this.activeError) this.activeError = null;
      });
  }

  handleCheckGrammarButton() {
    this.editorState.errors = {};
    this.editorState.chunks = [];
    this.editorState.results = {};
    this.editorState.status.all = 0;
    this.editorState.filteredErrors = {};

    if (!this.isCaptchaVerified) {
      this.verifyCaptcha();

      return;
    }

    if (this.authState !== 'pro') {
      if (this.editorState.words > this.authLimits[this.authState].words) {
        const p: HTMLButtonElement =
          document.querySelector('.word-limit-exceed');
        p.click();

        return;
      }
    }

    this.quillEditor.enable(false);
    this.submitting = true;

    this.quillEditor.root.querySelectorAll('span').forEach((span) => {
      let parent = span.parentNode;
      while (span.firstChild) {
        parent.insertBefore(span.firstChild, span);
      }
      parent.removeChild(span);
    });

    let content = this.convertTablesToParagraphs(
      this.fancyToPlain(this.quillEditor.root.innerHTML)
    );

    if (this.editorState.words > this.authLimits[this.authState].words) {
      this.quillEditor.root.innerHTML = this.splitTextByWordLimit(content);
      content = this.getQuillEditorFilteredText();
    }

    if (this.editorState.characters) {
      localStorage.setItem('editorValueAI', content);
    }

    if (this.authState !== 'guest' || window.innerWidth < 1203) {
      document
        .querySelector('.main--section')
        .querySelectorAll('button')
        .forEach((el) => {
          el.disabled = true;
        });
      this.quillEditor.root.style.opacity = '0.75';
      const data = JSON.stringify({
        homeText: content,
        profile_id: this.profile_id,
      });

      this.apiDataService
        .postResources(
          data,
          `${environment.API_URL}/api/getNewDocIDForGuestByContents`
        )
        .subscribe((data) => {
          const doc = data['new_doc_id'];

          window.location.href = `/grammar-check?doc=${doc}`;
        });
      return;
    }

    this.apiDataService
      .break_sentence(
        this.editorState.batch,
        content,
        null,
        {
          domain: 'academic',
          formality: 'formal',
        },
        this.profile_id,
        this.selectedLanguage
      )
      .subscribe((data) => {
        this.editorState.batch = data.batch;
        this.editorState.chunks = data.ChkLs;

        this.setFilteredInnerHTML(
          data.RetCnt.replace(/\u00A0/g, ' ').replace(/\u200B/g, '')
        );
        this.checkGrammar(data.ChkLs);
      });
  }

  checkGrammar(chunks: Array<string>) {
    let pendingRequests = chunks.length;
    const checkIfAllRequestsDone = () => {
      if (pendingRequests === 0) {
        this.submitting = false;
        this.quillEditor.enable();
        setTimeout(() => this.openFirstError(), 100);
      }
    };

    chunks.forEach((chunk) => {
      const el = document.getElementById(chunk) as HTMLElement;
      if (!el.textContent.trim().length) {
        pendingRequests--;
        checkIfAllRequestsDone();
        return;
      }

      const makeRequest = () => {
        this.apiDataService
          .grammarcheckerapi(
            el.innerText,
            this.selectedLanguage,
            {
              domain: 'academic',
              formality: 'formal',
            },
            chunk,
            null,
            this.editorState.batch,
            'p'
          )
          .subscribe((data) => {
            if (data.status === 'waiting' && !data.had_exception) {
              setTimeout(makeRequest, 1000);
            } else {
              pendingRequests--;
              checkIfAllRequestsDone();
            }

            this.editorState.results = {
              ...this.editorState.results,
              [chunk]: data.outConts,
            };

            this.formatEditorErrors();
            this.highlightErrors(chunk);
          });
      };
      makeRequest();
    });
  }

  formatEditorErrors() {
    Object.keys(this.editorState.results).forEach((chunk) => {
      const result = this.editorState.results[chunk];

      const errors = Object.entries({
        algMode: result.algMode,
        accMode: result.accMode,
        clrMode: result.clrMode,
      })
        .filter(([_, value]) => value.length > 0)
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {});

      this.editorState.errors = {
        ...this.editorState.errors,
        [chunk]: errors,
      };
    });

    this.editorState.errors = Object.fromEntries(
      Object.entries(this.editorState.errors).sort(
        ([a], [b]) => parseInt(a) - parseInt(b)
      )
    );

    this.computeResultsStatus();
    this.filteredErrors(this.showErrorsByType);
  }

  filteredErrors(filter: typeof this.showErrorsByType) {
    const sortedErrors = {};
    let filteredErrors: any = {};

    if (filter === 'all') {
      filteredErrors = this.editorState.errors;
    } else {
      this.Object.entries(
        this.editorState.errors as Record<
          string,
          Partial<
            Record<'accMode' | 'clrMode' | 'algMode', { errorType: string }[]>
          >
        >
      ).forEach(([key, modes]) => {
        let selectedErrors: Array<any> = [];

        if (filter === 'accMode') {
          selectedErrors = [
            ...(modes.accMode || []),
            ...(modes.algMode?.filter((e) => e.errorType === 'accuracy') || []),
          ];
        } else if (filter === 'clrMode') {
          selectedErrors = [
            ...(modes.clrMode || []),
            ...(modes.algMode?.filter((e) => e.errorType === 'clarity') || []),
          ];
        } else if (filter === 'syntaxMode') {
          selectedErrors = [
            ...(modes.algMode?.filter((e) => e.errorType === 'syntax') || []),
          ];
        } else if (filter === 'styleMode') {
          selectedErrors = [
            ...(modes.algMode?.filter(
              (e) => e.errorType === 'style' || e.errorType === 'redundency'
            ) || []),
          ];
        }

        if (selectedErrors.length) {
          filteredErrors[key] = selectedErrors;
        }
      });
    }

    for (const key in filteredErrors) {
      if (filteredErrors.hasOwnProperty(key)) {
        let allOffsets = [];

        for (const mode in filteredErrors[key]) {
          if (filteredErrors[key][mode]) {
            allOffsets = allOffsets.concat(filteredErrors[key][mode]);
          }
        }

        allOffsets.sort((a, b) => a.offset - b.offset);
        sortedErrors[key] = allOffsets;
      }
    }

    this.editorState.filteredErrors = Object.fromEntries(
      Object.entries(sortedErrors).filter(
        ([_, value]) => Array.isArray(value) && value.length > 0
      )
    );
  }

  computeResultsStatus() {
    let suggestions = 0,
      accuracy = 0,
      clarity = 0,
      style = 0,
      syntax = 0,
      grammar = 0;

    Object.keys(this.editorState.results).forEach((chunk) => {
      const result = this.editorState.results[chunk];

      suggestions += result.errors.Suggestion ?? 0;
      accuracy +=
        (result.accMode?.length ?? 0) +
        (result.algMode?.filter((e) => e.errorType === 'accuracy').length || 0);
      clarity +=
        (result.clrMode?.length ?? 0) +
        (result.algMode?.filter((e) => e.errorType === 'clarity').length || 0);
      style +=
        result.algMode?.filter(
          (e) => e.errorType === 'style' || e.errorType === 'redundency'
        ).length || 0;
      syntax +=
        result.algMode?.filter((e) => e.errorType === 'syntax').length || 0;
      grammar += result.errors.GrammarError ?? 0;
    });

    const sum = accuracy + clarity + style + syntax;
    const all = Number.isNaN(sum) ? 0 : sum;

    this.editorState.status = { all, accuracy };
  }

  highlightErrors(chunk: string) {
    const el = document.getElementById(chunk) as HTMLElement;
    const errors = this.editorState.errors[chunk];
    let text = el.textContent || '';

    const sortHighlights = () => {
      let highlights = [];

      const modesToShow: Array<string> = ['accMode', 'clrMode'];

      modesToShow.forEach((mode) => {
        if (errors[mode]) {
          errors[mode].forEach((error) => {
            error.highlights.forEach((highlight) => {
              highlights.push({
                highlight,
                offset: error.offset,
                length: error.length,
                UnderLine: error.UnderLine,
                Color: error.Color,
                ColorLight: error.ColorLight,
                unlocked: error.unlocked ?? false,
              });
            });
          });
        }
      });
      if (errors.algMode) {
        errors.algMode.forEach((error) => {
          let placed = false;
          for (let i = 0; i < highlights.length; i++) {
            const group = highlights[i];
            if (
              error.offset >= group.offset &&
              error.offset + error.length <= group.offset + group.length
            ) {
              highlights.push({
                offset: group.offset,
                length: group.length,
                highlight: error,
                UnderLine: group.UnderLine,
                Color: group.Color,
                ColorLight: group.ColorLight,
                unlocked: false,
              });
              placed = true;
              break;
            }
          }
          if (!placed) {
            highlights.push({
              UnderLine: error.UnderLine,
              offset: error.offset,
              length: error.length,
              highlight: error,
              Color: error.Color,
              ColorLight: error.ColorLight,
              unlocked: error.unlocked ?? false,
            });
          }
        });
      }

      return highlights.sort((a, b) => b.offset - a.offset);
    };

    const groupHighlightsByOffsetAndLength = (highlights) => {
      const grouped: Record<
        string,
        {
          offset: number;
          length: number;
          highlights: Array<any>;
          UnderLine?: string;
          Color: string;
          ColorLight: string;
          unlocked: boolean;
        }
      > = {};

      highlights.forEach(
        ({
          offset,
          length,
          highlight,
          UnderLine,
          Color,
          ColorLight,
          unlocked,
        }) => {
          const key = `${offset}-${length}`;

          if (!grouped[key])
            grouped[key] = {
              Color,
              ColorLight,
              UnderLine,
              offset,
              length,
              highlights: [],
              unlocked,
            };

          grouped[key].highlights.push(highlight);
        }
      );

      Object.values(grouped).forEach((group) => {
        group.highlights.sort((a, b) => b.offset - a.offset);
      });

      return Object.values(grouped);
    };

    const highlights = groupHighlightsByOffsetAndLength(sortHighlights());

    highlights.forEach((hl) => {
      const { offset, length, highlights, UnderLine, Color, unlocked } = hl;

      const model =
        highlights.find((h) => h.model)?.model ??
        Math.floor(Math.random() * 1000);
      const tread_id =
        highlights.find((h) => h.tread_id)?.tread_id ??
        Math.floor(Math.random() * 1000);

      let sentence = text.slice(offset, offset + length);

      highlights.forEach((highlight) => {
        const calculatedOffset = highlight.offset - offset;

        if (highlight.tread_id) {
          const wrong = sentence.slice(
            calculatedOffset,
            calculatedOffset + highlight.length
          );

          if (wrong === highlight.wrong) {
            sentence = `${sentence.slice(
              0,
              calculatedOffset
            )}<span class="error-highlight highlight-${
              highlight.model
            } error-highlight-${UnderLine}" id="${highlight.tread_id}-${
              highlight.offset
            }-${this.slugify(highlight.wrong)}" data-correction="${
              !unlocked &&
              highlight.model !== 'accuracy' &&
              ['guest', 'auth'].includes(this.authState)
                ? highlight.wrong
                : highlight.replace
            }" style="border-bottom: 2px ${
              UnderLine === 'DottedLine' ? 'dotted' : 'solid'
            } ${Color}">${sentence.slice(
              calculatedOffset,
              calculatedOffset + highlight.length
            )}</span>${sentence.slice(calculatedOffset + highlight.length)}`;
          }
        } else {
          const wrong = sentence.slice(
            calculatedOffset,
            calculatedOffset + highlight.length
          );

          if (wrong === highlight.wrong) {
            sentence = `${sentence.slice(
              0,
              calculatedOffset
            )}<span class="error-highlight highlight-${
              highlight.errorType
            }-algo" style="border-bottom: 2px ${
              highlight.UnderLine === 'DottedLine' ? 'dotted' : 'solid'
            } ${highlight.Color}" id="err-${highlight.ChkiD}-${
              highlight.offset
            }" data-correction="${
              ['guest', 'auth'].includes(this.authState) &&
              highlight.errorType !== 'accuracy'
                ? highlight.wrong
                : highlight.replacements[0]?.value ?? highlight.wrong
            }" data-highlight="${highlight.ColorLight}">${sentence.slice(
              calculatedOffset,
              calculatedOffset + highlight.length
            )}</span>${sentence.slice(calculatedOffset + highlight.length)}`;
          }
        }
      });

      text = `${text.slice(
        0,
        offset
      )}<span id="err-${tread_id}" class="entire-highlight entire-highlight-${model}" data-highlight="${
        hl.ColorLight
      }">${sentence}</span>${text.slice(offset + length)}`;
    });

    el.innerHTML = text;
    this.computeWordsAndCharactersCount();
  }

  clearEditor() {
    this.editorState.errors = {};
    this.editorState.results = {};
    this.editorState.chunks = [];
    this.editorState.status.all = 0;
    this.editorState.filteredErrors = {};
    this.quillEditor.setText(null);
    this.editorEnabled = false;
    this.activeError = null;

    this.computeWordsAndCharactersCount();
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);

    const el = document.getElementById('copy-to-clipboard-tooltip');
    this.copyText = 'editor.Copied';
    setTimeout(() => {
      this.copyText = 'editor.Copy';
    }, 2000);
  }

  computeWordsAndCharactersCount() {
    const editorText = this.quillEditor.getText().trim();
    const words = editorText.length ? editorText.split(/\s+/) : [];

    this.editorState.words = words.length;
    this.editorState.characters = editorText.length;
  }

  renderEditor() {
    this.editorEnabled = true;

    this.quillEditor.root.focus();
  }

  f(number: number): string {
    return number.toLocaleString();
  }

  toggleReportMenu(event: Event) {
    event.stopPropagation();

    const target = (event.target as HTMLElement).closest('button')
      ?.nextElementSibling as HTMLUListElement;

    if (!target) return;

    if (this.openMenu && this.openMenu !== target) {
      this.openMenu.style.display = 'none';
    }

    const cn: string = target.classList.contains('language-menu')
      ? 'grid'
      : 'block';

    target.style.display = target.style.display === cn ? 'none' : cn;
    this.openMenu = target.style.display === cn ? target : null;
  }

  switchLanguage(event) {
    const el = (event.target as HTMLElement).closest('li');

    if (!el) return;

    const language = el.getAttribute('data-language');
    this.selectedLanguage = language;
    this.openMenu.style.display = 'none';

    this.profile_id !== '1' &&
      this.apiDataService
        .updateUserLanguage(this.profile_id, language)
        .subscribe();

    this.iconRequireReattachment = true;
    setTimeout(() => {
      this.iconRequireReattachment = false;
    });
  }

  handleClickOutside = (event: Event) => {
    if (this.openMenu && !this.openMenu.contains(event.target as Node)) {
      this.openMenu.style.display = 'none';
      this.openMenu = null;
    }
  };

  convertTablesToParagraphs(html: string): string {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    doc.querySelectorAll('table').forEach((table) => {
      let newParagraphs = '';

      table.querySelectorAll('tr').forEach((row) => {
        let rowText: string[] = [];

        row.querySelectorAll('td, th').forEach((cell) => {
          rowText.push(cell.textContent?.trim() || '');
        });

        newParagraphs += `<p>${rowText.join(' | ')}</p>`;
      });

      const wrapper = document.createElement('div');
      wrapper.innerHTML = newParagraphs;
      table.replaceWith(...Array.from(wrapper.childNodes));
    });

    return doc.body.innerHTML;
  }

  handleEditorClick(event: Event) {
    this.autoInteraction = true;

    if (this.autoInteractionTimeout) {
      clearTimeout(this.autoInteractionTimeout);
    }

    const target = event.target as HTMLElement;

    if (!target.classList.contains('error-highlight')) {
      return;
    }

    setTimeout(() => {
      let errorTarget;

      if (
        ['guest', 'auth'].includes(this.authState) &&
        target.classList.contains('highlight-style-algo')
      ) {
        errorTarget = null;
      } else
        errorTarget =
          document.querySelector(`[data-error="${target.id}"]`) ??
          document.querySelector(
            `[data-error="${target.closest('.entire-highlight').id}"]`
          );

      if (!errorTarget) {
        let el: HTMLElement;
        if (
          target.classList.contains('highlight-clarity') ||
          target.classList.contains('highlight-clarity-algo')
        ) {
          el = document.getElementById('9eymM-HtPD2M-clr');
        } else if (target.classList.contains('highlight-style-algo')) {
          el = document.getElementById('9eymM-HtPD2M-sty');
        }

        el.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        });

        el.classList.add('shake');
        setTimeout(() => {
          el.classList.remove('shake');
        }, 1000);

        return;
      }

      errorTarget =
        document.querySelector(`[data-error="${target.id}"]`) ??
        document.querySelector(
          `[data-error="${target.closest('.entire-highlight').id}"]`
        );

      const highlight: HTMLElement = target.dataset['highlight']
        ? target
        : target.closest('.entire-highlight');

      this.removeClassFromAllSiblings(errorTarget, 'expanded');
      this.quillEditor.root.querySelectorAll('span').forEach((span) => {
        span.style.removeProperty('background-color');
      });
      highlight?.setAttribute(
        'style',
        `${
          highlight?.getAttribute('style')
            ? highlight?.getAttribute('style') + ';'
            : ''
        } background-color: ${highlight.dataset['highlight']} !important`
      );

      errorTarget.classList.add('expanded');
      errorTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });

      this.extractError(
        target.id.startsWith('err-')
          ? target.id
          : target.closest('.entire-highlight').id
      );
    }, 0);

    this.autoInteractionTimeout = setTimeout(() => {
      this.autoInteraction = false;
      this.autoInteractionTimeout = null;
    }, 100);
  }

  removeClassFromAllSiblings(el: HTMLElement, className: string) {
    Array.from(el.parentElement.children).forEach((child) => {
      if (child !== el && child.classList.contains(className)) {
        child.classList.remove(className);
      }
    });
  }

  removeErrorHighlightsFromText() {
    const highlights = this.quillEditor.root.querySelectorAll('span');

    highlights.forEach((highlight) => {
      let parent = highlight.parentNode;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });
  }

  // removeErrorHighlightsFromText() {
  //   const highlights = this.quillEditor.root.querySelectorAll('span');

  //   if (!highlights.length) return;
  //   if (this.autoInteraction) return;

  //   this.cursor = this.quillEditor.getSelection();

  //   highlights.forEach((highlight) => {
  //     let parent = highlight.parentNode;
  //     while (highlight.firstChild) {
  //       parent.insertBefore(highlight.firstChild, highlight);
  //     }
  //     parent.removeChild(highlight);
  //   });

  //   setTimeout(() => {
  //     this.quillEditor.setSelection(this.cursor);
  //   }, 0);
  // }

  slugify(str: string) {
    return String(str)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9 -]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  highlightErrorInEditor(event: Event, background: string) {
    const el = document.getElementById(
      (event.target as HTMLElement).closest('li').dataset['error']
    );
    el?.setAttribute(
      'style',
      `${
        el?.getAttribute('style') ? el?.getAttribute('style') + ';' : ''
      } background-color: ${background} !important`
    );
  }

  removeHighlightInEditor(event: Event) {
    const target = (event.target as HTMLElement).closest('li');
    const el = document.getElementById(
      (event.target as HTMLElement).closest('li').dataset['error']
    );

    if (!el) return;

    target.classList.contains('expanded') || (el.style.backgroundColor = '');
  }

  toggleErrorListExpand(event: Event, background: string) {
    this.activeError = null;
    const el = (event.target as HTMLElement).closest('li');

    this.removeClassFromAllSiblings(el, 'expanded');
    el.classList.toggle('expanded');

    if (!background.length) return;

    const t = document.getElementById(`${el.dataset['error']}`);
    t?.setAttribute(
      'style',
      `${
        t?.getAttribute('style') ? t?.getAttribute('style') + ';' : ''
      } background-color: ${background} !important`
    );

    const errorHighlights = this.quillEditor.root.querySelectorAll(
      '.error-highlight, .entire-highlight'
    );

    errorHighlights.forEach((highlight) => {
      if (highlight !== t) {
        (highlight as HTMLElement).style.backgroundColor = '';
      }
    });

    this.setCursorInEditor(t);
    t.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  formatReplacementsArray(replacements: Array<string>): string {
    return replacements
      .map((replacement) => {
        if (replacement.startsWith('#@-@#')) {
          return `<strong class="text-color-danger text-decoration-line-through">${replacement
            .slice(5)
            .trim()}</strong>`;
        }

        if (replacement.startsWith('#@+@#')) {
          return `<strong class="text-color-primary">${replacement
            .slice(5)
            .trim()}</strong>`;
        }

        return replacement;
      })
      .join(' ');
  }

  handleDismiss(event: Event, type?: string) {
    this.activeError = null;
    const button = (event.target as HTMLElement).closest('button');
    const target = button.dataset['target'];

    const el = document.getElementById(target);
    const parent = el.parentNode as HTMLElement;

    parent.insertBefore(document.createTextNode(el.innerText), el);
    parent.removeChild(el);

    this.removeModesByTreadId(target.slice(4), false);
    let prevError = button.closest('li').previousElementSibling;
    let nextError = button.closest('li').nextElementSibling;

    while (nextError && nextError.classList.contains('premium-suggestion')) {
      nextError = nextError.nextElementSibling;
    }

    if (nextError) {
      (nextError.querySelector('.expand-toggler') as HTMLElement).click();
    } else {
      while (prevError && prevError.classList.contains('premium-suggestion')) {
        prevError = prevError.previousElementSibling;
      }

      if (prevError) {
        (prevError.querySelector('.expand-toggler') as HTMLElement).click();
      }
    }

    button.closest('li').remove();
    this.filteredErrors(this.showErrorsByType);
  }

  removeModesByTreadId(chunk: string, dec: boolean = true) {
    const treadId = chunk.split('-').slice(0, 3).join('-');
    const offset = chunk.split('-').slice(3).join('-');
    const key = chunk.split('-').slice(0, 2).join('-');
    const errors = this.editorState.errors[key];

    const modes: Array<string> =
      treadId === chunk ? ['accMode', 'clrMode'] : ['algMode'];

    modes.forEach((mode) => {
      if (errors[mode]) {
        for (let i = errors[mode].length - 1; i >= 0; i--) {
          const error = errors[mode][i];

          if (
            (mode === 'algMode' &&
              error.ChkiD === treadId &&
              error.offset === Number(offset)) ||
            (mode !== 'algMode' && error.ChkiD === treadId)
          ) {
            errors[mode].splice(i, 1);
          }
        }

        // if (dec) {
        //   if (errors[mode].errorType) {
        //     errors[mode][0].errorType === 'modAcc'
        //       ? (this.editorState.status.accuracy -= 1)
        //       : (this.editorState.status.clarity -= 1);
        //   } else {
        //     this.editorState.status.style -=
        //       this.editorState.status.style > 0 ? 1 : 0;
        //   }
        // }

        if (errors[mode].length === 0) {
          delete this.editorState.errors[key][mode];
        }
      }
    });

    if (Object.keys(errors).length === 0) {
      delete this.editorState.errors[key];
    }

    // this.editorState.status.all -= 1;
    this.computeResultsStatus();
  }

  handleCorrection(event: Event) {
    this.activeError = null;
    const button = (event.target as HTMLElement).closest('button');
    const target = button.dataset['target'];

    const el = document.getElementById(target);
    let correction;
    let resendGrammarRequest = false;

    try {
      correction =
        JSON.parse(button.dataset['correction']) ||
        button.dataset['correction'];

      correction = button.dataset['correct'];
    } catch {
      correction = button.dataset['correction'];
      resendGrammarRequest = false;
    }

    const parent = el.parentNode as HTMLElement;

    const spans = Array.from(
      el.querySelectorAll<HTMLElement>(
        '.highlight-accuracy-algo, .highlight-style-algo'
      )
    );

    if (
      el.classList.contains('highlight-style-algo') ||
      el.classList.contains('highlight-accuracy-algo')
    ) {
      const parent = el.parentNode as HTMLElement;

      parent.insertBefore(document.createTextNode(correction), el);
      parent.removeChild(el);
    } else {
      const frag = document.createDocumentFragment();
      let pos = 0;

      for (const span of spans) {
        const text = span.textContent;
        if (!text) continue;

        const idx = correction.indexOf(text, pos);
        if (idx === -1) {
          frag.appendChild(document.createTextNode(correction.slice(pos)));
          pos = correction.length;
          break;
        }

        const before = correction.slice(pos, idx);
        frag.appendChild(document.createTextNode(before));

        const wrapper = document.createElement('span');
        wrapper.classList.add('entire-highlight');
        wrapper.appendChild(span.cloneNode(true));
        frag.appendChild(wrapper);

        pos = idx + text.length;
      }

      if (pos < correction.length) {
        frag.appendChild(document.createTextNode(correction.slice(pos)));
      }

      parent.replaceChild(frag, el);
    }

    this.removeModesByTreadId(target.slice(4));

    let prevError = button.closest('li').previousElementSibling;
    let nextError = button.closest('li').nextElementSibling;

    while (nextError && nextError.classList.contains('premium-suggestion')) {
      nextError = nextError.nextElementSibling;
    }

    if (nextError) {
      (nextError.querySelector('.expand-toggler') as HTMLElement).click();
    } else {
      while (prevError && prevError.classList.contains('premium-suggestion')) {
        prevError = prevError.previousElementSibling;
      }

      if (prevError) {
        (prevError.querySelector('.expand-toggler') as HTMLElement).click();
      }
    }

    button.closest('li').remove();
    this.filteredErrors(this.showErrorsByType);

    if (this.profile_id === '1' && this.editorState.status.accuracy === 0) {
      this.handleCheckGrammarButton();
    }
  }

  correctAll() {
    const highlights =
      this.quillEditor.root.querySelectorAll('.error-highlight');

    highlights.forEach((highlight) => {
      highlight.innerText = highlight.dataset['correction'];
    });

    this.editorState.errors = {};
    this.editorState.results = {};
    this.editorState.chunks = [];
    this.editorState.status.all = 0;
    this.editorState.filteredErrors = {};
    this.removeErrorHighlightsFromText();
  }

  splitTextByWordLimit(innerHTML: string): string {
    let parser = new DOMParser();
    let doc = parser.parseFromString(innerHTML, 'text/html');
    let elements = Array.from(doc.body.children);

    let selectedElements: string[] = [];
    let wordCount = 0;
    let limit = this.authLimits[this.authState].words;

    let remainingElements: HTMLElement[] = [];

    elements.forEach((el) => {
      let text = el.textContent?.trim() || '';
      let words = text.split(/\s+/);
      let wordsInElement = words.length;

      if (wordCount + wordsInElement <= limit) {
        selectedElements.push(el.outerHTML);
        wordCount += wordsInElement;
      } else if (wordCount < limit) {
        let firstPart = words.slice(0, limit - wordCount).join(' ');
        let secondPart = words.slice(limit - wordCount).join(' ');

        let firstEl = `<${el.tagName.toLowerCase()}>${firstPart}</${el.tagName.toLowerCase()}>`;
        let secondEl = `<${el.tagName.toLowerCase()} class="E93fKL-PD_2">${secondPart}</${el.tagName.toLowerCase()}>`;

        selectedElements.push(firstEl);
        remainingElements.push(
          new DOMParser().parseFromString(secondEl, 'text/html').body
            .firstChild as HTMLElement
        );
        wordCount = limit;
      } else {
        el.classList.add('E93fKL-PD_2');
        remainingElements.push(el as HTMLElement);
      }
    });

    let uncheckedHTML = remainingElements.map((el) => el.outerHTML).join('');
    return selectedElements.join('') + uncheckedHTML;
  }

  setFilteredInnerHTML(newHTML) {
    const element = this.quillEditor.root;
    let parser = new DOMParser();
    let doc = parser.parseFromString(newHTML, 'text/html');
    let newElements = Array.from(doc.body.children);
    let uncheckedElements = Array.from(
      element.querySelectorAll('.E93fKL-PD_2')
    );

    element.innerHTML = newElements.map((el) => el.outerHTML).join('');
    uncheckedElements.forEach((el) => element.appendChild(el));
  }

  getQuillEditorFilteredText() {
    const el = this.quillEditor.root;

    const clone = el.cloneNode(true) as HTMLElement;
    clone.querySelectorAll('.E93fKL-PD_2').forEach((el) => el.remove());

    return clone.innerHTML;
  }

  openFirstError() {
    const list: HTMLUListElement = document.getElementById(
      'corrections-container'
    ) as HTMLUListElement;

    if (!list.children.length) return;

    (
      list.firstElementChild.querySelector(
        '.expand-toggler'
      ) as HTMLButtonElement
    ).click();
  }

  setCursorInEditor(t: HTMLElement) {
    const range = document.createRange();
    const selection = window.getSelection();

    range.setStart(t, t.childNodes.length);
    range.setEnd(t, t.childNodes.length);

    selection.removeAllRanges();
    selection.addRange(range);
  }

  dismissModal(event: Event) {
    (
      (event.target as HTMLElement).closest('.wrapper') as HTMLElement
    ).style.display = 'none';
  }

  selectPlan(id: string) {
    const plan = this.plans.find((plan) => plan.id === id);
    localStorage.setItem('price_id', id);
    localStorage.setItem('plan', plan.title);
    localStorage.setItem('amount', plan.amount);

    window.open('/plans', '_blank');
  }

  invokeModal(event: Event) {
    let targetId;
    try {
      targetId = (event.target as HTMLElement).closest('button').dataset[
        'target'
      ];
    } catch {
      if (!targetId) {
        targetId = (event.target as HTMLElement).closest('li').dataset[
          'target'
        ];
      }
    }

    document.getElementById(targetId).style.display = 'grid';
  }

  redirectToTool(event: Event, path: string) {
    event.preventDefault();
    const clone = document.getElementById('mm').cloneNode(true) as HTMLElement;
    clone.querySelectorAll('span').forEach((el) => {
      const parent = el.parentElement;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
    const text = clone.innerHTML;
    localStorage.setItem('editorValueAI', text);
    this.router.navigate([path]);
  }

  private extractChunkId(id: string) {
    id = id.replace(/^err-/, '');

    return id.split('-').slice(0, 3).join('-');
  }

  private extractError(id: string) {
    const target = document.getElementById(id) as HTMLSpanElement;
    const targetRect = target.getBoundingClientRect();
    const offset: number | null = id.startsWith('err-')
      ? parseInt(id.split('-')[4])
      : null;
    id = this.extractChunkId(id);

    const errObj =
      this.editorState.filteredErrors[id.split('-').slice(0, 2).join('-')];

    const err = offset
      ? errObj.filter((err) => err.ChkiD === id && err.offset === offset)
      : errObj.filter((err) => err.ChkiD === id);

    this.activeError = err[0];

    setTimeout(() => {
      const popup: HTMLDivElement = document.querySelector('.error-popup');

      popup.style.display = 'block';
      popup.style.top = `${
        (window.scrollY + targetRect.top + target.offsetHeight + 6) / 16
      }rem`;
      popup.style.left = `${
        (targetRect.left + target.offsetWidth / 2) / 16
      }rem`;

      this.openMenu = popup;
    }, 0);
  }

  captchaVisible: boolean = false;
  recaptchaMessage: string = '';
  color: string;
  captchaToken: string | null = null;
  isCaptchaVerified: boolean = false;

  private verifyCaptcha() {
    if (this.captchaVisible) {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';
      this.color = '#721c24';
      return;
    }

    this.captchaVisible = true;
    this.cdr.detectChanges();
    this.loadAndRenderTurnstile();
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => document.body.appendChild(script);

      return;
    }
    this.renderTurnstile();
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
  }

  onTurnstileSuccess(token: string): void {
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.handleCheckGrammarButton();
  }

  onTurnstileError(): void {
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    }
  }

  handlePseudoCorrection(
    event: Event,
    mode: Readonly<'Accept' | 'Dismiss'> = 'Accept'
  ): void {
    const el = event.target as HTMLButtonElement;
    const corrections: HTMLUListElement = document.querySelector(
      '#corrections-container'
    );

    const className: string =
      mode === 'Accept' ? 'accept-button' : 'dismiss-button';

    const t: HTMLButtonElement = corrections.querySelector(
      `[data-target="${el.dataset['target']}"].${className}`
    );

    if (!t) return;

    t.click();
  }

  handlePseudoCorrectionOneWord(event: Event): void {
    const el = event.target as HTMLButtonElement;

    const corrections: HTMLUListElement = document.querySelector(
      '#corrections-container'
    );

    const t: HTMLButtonElement = corrections.querySelector(
      `[data-target="${el.dataset['target']}"]`
    );

    if (!t) return;

    t.click();
  }

  private fancyToPlain(text) {
    let plain = '';

    for (let char of text) {
      let code = char.codePointAt(0);

      if (code >= 0x1d608 && code <= 0x1d621) {
        plain += String.fromCharCode(code - 0x1d608 + 0x41);
      } else if (code >= 0x1d622 && code <= 0x1d63b) {
        plain += String.fromCharCode(code - 0x1d622 + 0x61);
      } else {
        plain += char;
      }
    }
    return plain;
  }
  private updateEditorPlaceholder(): void {
    this.getTranslated('editor.Placeholder', (translated) => {
      this.quillEditor.root.dataset.placeholder = translated;
    });
  }

  private getTranslated(
    key: string,
    callback: (translated: string) => void
  ): void {
    this.translate.get(key).subscribe(callback);
  }
}
